import "core-js/modules/es.array.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { throttle } from '@vip-activity/utils';
var selector = ['.mod_ticket', '.mod_call', '.mod_game', '.mod_intro'];
export default {
  data: function data() {
    return {
      index: 0,
      isShowFixNav: false,
      height: 60,
      list: ['购买影票', '冲刺魂力榜', '互动抽奖', '云首发介绍']
    };
  },
  methods: {
    select: function select(index) {
      var el = document.querySelector(selector[index]);

      if (el) {
        this.index = index;
        window.scroll({
          left: 0,
          top: el.offsetTop - this.height
        });
      }
    },
    goToEl: function goToEl(selectorCls) {
      var el = document.querySelector(selectorCls);

      if (!el) {
        return;
      }

      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      if (typeof window.history !== 'undefined') {
        if ('scrollRestoration' in window.history) {
          window.history.scrollRestoration = 'manual';
        }
      }

      window.scroll({
        left: 0,
        top: scrollTop + el.getBoundingClientRect().y - this.height
      });
    },
    initOffset: function initOffset() {
      if (!this.offset || this.offset === 'none') return;
      var selectorCls = this.offset === 'pg2' ? '.xm_ticket_item' : '.dm_ticket_item';

      if (typeof window.history !== 'undefined') {
        if ('scrollRestoration' in window.history) {
          window.history.scrollRestoration = 'manual';
        }
      }

      this.goToEl(selectorCls);
    },
    bindEvent: function bindEvent() {
      var _this = this;

      this.eventBus.$on('scrollToBox', function () {
        _this.select(1);
      });
      this.eventBus.$on('initOffset', function () {
        _this.initOffset();
      });
      this.eventBus.$on('gotoEl', function (selectCls) {
        _this.goToEl(selectCls);
      });
    }
  },
  created: function created() {
    this.bindEvent();
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      // 导航滚动监听事件
      var nav = _this2.$el;
      _this2.height = nav.offsetHeight || 60;
      window.addEventListener('scroll', throttle(function () {
        if (!nav) return;
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        var h = nav.offsetTop - scrollTop;
        _this2.isShowFixNav = h < 0; // 滑动到指定楼层点亮
        // 计算4个导航分别距离顶部的距离

        selector.forEach(function (s, index) {
          var el = document.querySelector(s);

          if (!el) {
            return;
          }

          var top = el.offsetTop;

          if (top - scrollTop - (_this2.height + 10) < 0) {
            _this2.index = index;
          }

          if (index === 0 && scrollTop < top) {
            _this2.index = 0;
          }
        });
      }));
    });
  }
};